import * as t from "io-ts";
import nullable from "./nullable";
import { placeT } from "./place";
import { cargoTypeT } from "./types";
export const createLiveViewTypes = ({ dateTime, decimal, }) => {
    const vehicleDetailsLocationDataT = t.strict({
        id: t.string,
        type: t.union([t.literal("CARGO_STOP"), t.literal("WAYPOINT")]),
        completedAt: nullable(dateTime),
        originalOrderNumber: t.number,
        address: t.string,
        coords: t.strict({
            lat: t.number,
            lon: t.number,
        }),
        cargoId: nullable(t.string),
        clientId: nullable(t.string),
        packageInfo: nullable(t.strict({
            cargoType: cargoTypeT,
            lm: decimal,
        })),
    });
    const vehicleForLiveViewBaseT = t.strict({
        truckId: t.string,
        trailerIds: t.array(t.string),
        driverId: nullable(t.string),
        routeId: nullable(t.string),
    });
    const vehicleForLiveViewT = t.intersection([
        vehicleForLiveViewBaseT,
        t.strict({ destinationAddress: nullable(placeT) }),
    ]);
    const vehiclesForLiveViewT = t.array(vehicleForLiveViewT);
    const liveViewOverviewT = t.strict({
        vehicles: vehiclesForLiveViewT,
        unavailableRouteIds: t.array(t.string),
    });
    const routeForLiveViewT = t.strict({
        vehicle: vehicleForLiveViewBaseT,
        driverStartDayDate: nullable(dateTime),
        pastLocations: t.array(vehicleDetailsLocationDataT),
        futureLocations: t.array(vehicleDetailsLocationDataT),
    });
    return {
        vehicleForLiveViewT,
        vehiclesForLiveViewT,
        liveViewOverviewT,
        routeForLiveViewT,
        vehicleDetailsLocationDataT,
    };
};
//# sourceMappingURL=live-view.js.map